<template>
  <div class="device-monitor_map">
    <MapLibreGL ref="maplibre" @loaded="mapLoaded" :theme="theme" />
  </div>
</template>

<script>
import MapLibreGL from '@/components/maplibre/index.vue';
import { colors, infoContent, isValidCoordinate, bmap2CGCS2000 } from '@/utils/bmapUtil';
import { stateMapMarker as smm } from '@/utils/dict';
import { mapState } from 'vuex';
import { isDevice } from '@/utils/deviceUtils';

export default {
  name: 'monitorMap',
  components: { MapLibreGL },
  data() {
    return {
      labelMap: {},
      markerMap: {},
      mapApp: null,
      deviceList: []
    };
  },
  computed: {
    ...mapState('app', ['theme']),
    ...mapState('socket', ['devicesSourseMap', 'deviceIdMap']),
    ...mapState('device', ['monitorMenuActive', 'monitorConfig']),
    filterNoPosDevices() {
      return this.devicesSourseMap.filter(e => e.latitude !== 0 || e.longitude !== 0);
    }
  },
  methods: {
    mapLoaded(mapApp) {
      this.mapApp = mapApp;
      this.$nextTick(() => {
        const map = this.mapApp.map;
        map.jumpTo({ center: [106.387456, 34.925406], zoom: 5 });

        this.initMarkers({
          source: this.filterNoPosDevices,
          markerMap: this.markerMap
        });
        this.monitorMenuActiveChange(this.monitorMenuActive);
      });
    },
    createMarkerEl(state) {
      const el = document.createElement('div');
      el.className = 'device-marker';
      el.style.cursor = 'pointer';
      const img = document.createElement('img');
      img.src = smm[state] || smm['-1'];
      img.style.width = '32px';
      img.style.height = '32px';
      el.appendChild(img);
      return el;
    },
    initMarkers({ source, markerMap }) {
      source.forEach(e => {
        if (!isValidCoordinate([e.longitude, e.latitude])) return;
        const el = this.createMarkerEl(e.state);
        const coord = bmap2CGCS2000([e.longitude, e.latitude]);
        const marker = this.mapApp.addMarker({
          markerOpts: { element: el },
          coord,
          html: this.showInfoWindow(e)
        });
        markerMap[e.sn] = { marker, el, state: e.state };
      });
    },
    showInfoWindow({ name, state = -1, sn, parentId, deviceType }) {
      return infoContent({
        name,
        state,
        sn,
        deviceType,
        colors,
        parentId,
        deviceIdMap: this.deviceIdMap,
        router: this.$router
      });
    },
    locateTo({ latitude, longitude, sn, name }) {
      if (!latitude || !longitude) {
        return this.$message.warning(`${name}暂无坐标信息`);
      }

      const coordinate = bmap2CGCS2000([longitude, latitude]);
      const labelMap = this.labelMap;
      const map = this.mapApp.map;

      Object.keys(labelMap).forEach(e => {
        if (e !== sn && labelMap[e]) {
          labelMap[e].remove();
          labelMap[e] = null;
        }
      });

      this.setLabel({ sn, coordinate, content: name, map, labelMap });
      map.flyTo({ center: coordinate, zoom: 18, duration: 1500 });
    },
    setLabel({ sn, coordinate, content, map, labelMap }) {
      let label = labelMap[sn];

      if (!label) {
        const el = document.createElement('div');
        el.className = 'map-label';
        el.style.cssText =
          'color:#000;font-size:16px;border:2px solid #1E90FF;border-radius:8px;padding:2px 5px;background:#fff;white-space:nowrap;';
        el.textContent = content;

        label = new maplibregl.Popup({
          closeButton: false,
          closeOnClick: false,
          offset: [0, -55],
          className: 'device-label-popup'
        })
          .setLngLat(coordinate)
          .setDOMContent(el)
          .addTo(map);

        labelMap[sn] = label;
      } else {
        const el = label.getElement();
        if (el) {
          const labelEl = el.querySelector('.map-label');
          if (labelEl) labelEl.textContent = content;
        }
      }
    },
    updateMarker(v) {
      v.forEach(e => {
        const { sn, state, longitude, latitude } = e || {};
        if (!sn || !this.markerMap[sn]) return;

        const entry = this.markerMap[sn];
        const { marker, el } = entry;

        if (entry.state !== state) {
          const img = el.querySelector('img');
          if (img) {
            img.src = smm[state] || smm['-1'];
          }
          entry.state = state;
        }

        if (longitude !== 0 || latitude !== 0) {
          const pos = marker.getLngLat();
          if (pos.lng !== longitude || pos.lat !== latitude) {
            marker.setLngLat(bmap2CGCS2000([longitude, latitude]));
          }
        }
      });
    },
    monitorMenuActiveChange(n) {
      if (!isDevice(n.nodeType)) return;
      const device = this.deviceIdMap[n.id];

      this.locateTo(device);
    }
  },
  watch: {
    filterNoPosDevices: {
      handler: 'updateMarker',
      deep: true
    },
    monitorMenuActive: {
      handler: 'monitorMenuActiveChange',
      deep: true
    }
  },
  beforeDestroy() {
    Object.values(this.markerMap).forEach(entry => {
      if (entry && entry.marker) entry.marker.remove();
    });
    Object.values(this.labelMap).forEach(label => {
      if (label) label.remove();
    });
  }
};
</script>

<style lang="scss">
.device-monitor_map {
  height: 100%;
}

.device-label-popup .maplibregl-popup-content {
  padding: 0;
  background: transparent;
  box-shadow: none;
}

.device-label-popup .maplibregl-popup-tip {
  display: none;
}
</style>
